import FilterReducer from 'app/Core/Components/Filter/Store/Reducers/FilterReducer';
import { combineReducers } from 'redux';
import TagFuncionalidadeReducer from 'app/ERP/TagFuncionalidade/Store/Reducers/TagFuncionalidadeReducer';
import MinhasTarefasReducer from './MinhasTarefasReducer';

const reducer = combineReducers({
    FilterReducer,
    MinhasTarefasReducer,
    TagFuncionalidadeReducer,
});

export default reducer;
